import { Injectable } from '@angular/core';
import { CoreApiService } from 'src/app/core/core-api.service';
import { endpoints } from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class BancoService {

  constructor(private apiService: CoreApiService) { }

  listarBancos(){
    let params = {}
    return this.apiService.get(endpoints.listarBancos, {params})
  }

  listarCorretoras(param){
    let params = {idRegime: param}
    return this.apiService.get(endpoints.listarCorretoras, {params})
  }
}
